import React, { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Container from 'react-bootstrap/Container';
import Video_steamer from "./Video_streamer/Video_steamer";

function App() {
  return (
      <Container fluid="md" >
          <BrowserRouter>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Video_steamer />} />
                </Routes>
            </div>
          </BrowserRouter>
      </Container>
  );
}

export default App;
